import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, reason: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.SUBSCRIPTION_CANCEL_REASON_CREATE_REQUEST:
      return { ...INITIAL_STATE, loading: true, reason: null, error: null };
    case CONST.SUBSCRIPTION_CANCEL_REASON_CREATE_SUCCESS:
      return { ...INITIAL_STATE, loading: false, reason: action.data.data, error: null };
    case CONST.SUBSCRIPTION_CANCEL_REASON_CREATE_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error, reason: null };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, reason: null };
    default:
      return state;
  }
};
